import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ConditionalWrapper from 'components/application/ConditionalWrapper';
import SmallStubPill from 'components/application/pills/SmallStubPill';
import Tooltip from 'components/application/Tooltip';

import { formatDate, isBefore } from 'components/helpers/dates';

export default function RegularCourseBookedPill({ booking }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'courses.pills.RegularCourseBookedPill',
  });

  const { date } = booking.attributes;

  const hasDateReached =
    date &&
    !isBefore({
      date: new Date(),
      dateToCompare: date,
    });

  return (
    <ConditionalWrapper
      condition={!!date}
      wrapper={(children) => (
        <Tooltip
          placement='top-end'
          tooltip={i18nT('tooltip', {
            date: formatDate({ date, format: 'd MMM yyyy' }),
          })}
          trigger='hover'
        >
          {children}
        </Tooltip>
      )}
    >
      <SmallStubPill
        className={classNames(
          'tw-align-middle',
          hasDateReached ?
            'tw-bg-cyan-025 tw-text-cyan-800'
          : 'tw-bg-green-025 tw-text-green-800',
        )}
      >
        {i18nT('pill')}
      </SmallStubPill>
    </ConditionalWrapper>
  );
}

RegularCourseBookedPill.propTypes = {
  booking: PropTypes.object.isRequired,
};
